/** dependencies which might be called outside of our own javascript */
import 'foundation-sites';
import 'slick-carousel/slick/slick';



// WEBPACK FOOTER //
// ./scripts/vendor.js